export default __webpack_public_path__ + "static/media/theme_cowboys.42378ff9.jpg";